/** Статусы платежа PayOnlineGate (не путать с PaymentStatusEnum заявки). */
export enum PayOnlinePaymentStatusEnum {
	notPaid = 0,
	pending = 1,
	invalid = 2,
	/** Платеж совершен */
	paid = 3,
	cancelled = 4,
	expired = 5,
	notified = 6
}
